export function prependApiUrl(str) {
  return `${process.env.GATSBY_API_URL}${str}`;
};

export function formatPublishDate(date) {
  return new Date(date).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}